import emoji from 'markdown-it-emoji';
import bare from 'markdown-it-emoji/bare';
import light from 'markdown-it-emoji/light';

export default emoji;

export {bare, light};
